'use client';
import { useRef as f, useEffect as i } from "react";
import { useIsomorphicLayoutEffect as E } from "./use-isomorphic-layout-effect.js";
function L(t, r, u, n) {
  const s = f(r);
  E(() => {
    s.current = r;
  }, [r]), i(() => {
    const e = window;
    if (!(e && e.addEventListener)) return;
    const o = (c) => {
      s.current(c);
    };
    return e.addEventListener(t, o, n), () => {
      e.removeEventListener(t, o, n);
    };
  }, [t, u, n]);
}
export {
  L as useEventListener
};
